import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ImgLoaderService } from './services/img-loader.service';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  selector: 'app-root',
  styleUrl: './app.scss',
  templateUrl: './app.html',
})
export class App {
  constructor(
    private readonly imgLoaderService: ImgLoaderService
  ) {
    this.imgLoaderService.loadImages();
  }

  public onActivate(): void {
    window.scroll(0, 0);
  }
}
